import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function TextSliderSkeleton() {
    return <Skeleton height={140} />;
}
